import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/callback")({
  beforeLoad: () => {
    setInterval(() => {
      window?.parent.postMessage("orderPageOpen", "*");
    }, 40);
  },
});
